import $ from 'jquery';

$(document).ready(function () {
  const $c = $('[data-custom-cursor]');
  const $SliderSection = $('.slider');
  const $SliderSectionEn = $('.slider-en');

  $SliderSection.hover(
    () => $c.addClass('slider'),
    () => $c.removeClass('slider')
  );

  $SliderSectionEn.hover(
    () => $c.addClass('slider-en'),
    () => $c.removeClass('slider-en')
  );

  $(window).on('mousemove', ({ clientX: x, clientY: y }) => {
    $c.css({ transform: `translate(${x}px, ${y}px)` });
  });
});
